
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import { pharmacies as enPharmacies } from './local/en/pharmacies';
import { pharmacies as esPharmacies } from './local/es/pharmacies';
import { pharmacies as zhPharmacies } from './local/zh/pharmacies';

const resources = {
  en: {
    pharmacies: enPharmacies
  },
  es: {
    pharmacies: esPharmacies
  },
  zh: {
    pharmacies: zhPharmacies
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    ns: ['pharmacies'],
    defaultNS: 'pharmacies'
  });

export default i18n;
